module.exports = __webpack_public_path__ + "media/images/icon__arrow-left@2x-c9f1ef16562b837ae4765cbe6ee10243.png";